import styled from 'styled-components';
import { breakpoints, colors } from '../../constants';

interface IProps {
    secondary?: boolean;
}

export const Button = styled.button.attrs(() => ({
    type: 'button',
}))<IProps>`
    appearance: none;
    border: 0;
    height: 48px;
    padding: 0 20px;
    font-size: 1rem;
    font-weight: 300;
    background-color: ${({ secondary }) =>
        secondary ? colors.greyBackground : colors.black};
    color: ${({ secondary }) => (secondary ? colors.black : colors.white)};
    border-radius: 3px;
    cursor: pointer;
    transition: background-color 0.2s linear;
    width: 100%;
    min-width: 130px;

    @media (${breakpoints.mediumMin}) {
        width: fit-content;

        :hover {
            text-decoration: none;
            background-color: ${({ secondary }) =>
                secondary ? colors.greyHover : colors.blackHover};
        }
    }
`;
